/**
 * @file Level Configuration Constants
 * @description Defines the configuration for game levels, including evidence requirements
 * and time limits. These constants are used throughout the game to determine level progression.
 */

import type { GameConfig } from '../types';

/**
 * Default game configuration settings.
 * Used as the base layer in useGameConfig — remote config values override these.
 */
export const GAME_CONFIG: GameConfig = {
  timer: 0,
  minimumEvidence: 0,
  endWhenAllFound: false,
  missClickPenalty: 3,
  firstCaseId: 'case1',
  videoSegmentLength: 30,
  streakTimeThreshold: 3,
  timeBonusBase: 4,
  showOnboardingVideo: true,
  ftueVideoVersion: 1,
  ftueHighlightTimeoutSeconds: 5,
  ftueArrowHighlightTimeoutSeconds: 3,
  ftueHintHighlightTimeoutSeconds: 10,
  idleTimeoutSeconds: 60,
  hintBaseCooldown: 30,
  parTime: 90,
  aceTime: 60,
  conversationBubbleAutoFadeMs: 6000,
};
